import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_utpfre3a3e: FaireCollectionEntity = {
  token: "pbc_utpfre3a3e",
  type: "collection",
  name: "Siblings & Family 👨‍👩‍👧‍👦 👨‍👩‍👧‍👦",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a9a37fdd0c8a69ef0bf63fce7cb8e8ab06062a1cd4682e751b5f1be2eeb8caa3.jpeg",
  itemCount: 51,
  description:
    "Is someone about to become a big sister or big brother?! Customers love to dress their first born in these tees and crewnecks as a way to announce that a new little brother or sister is on the way.",
  brandToken: "b_gro99lye",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-12T06:26:37.459Z",
    importedBy: "entity-db-import-collections",
  },
};
